<div class="label-properties-panel">
  <small class="debug">{{me}}</small>
  @if (isTouchMode) {
    <button mat-raised-button color="primary" (click)="onTouchAction()">
      <mat-icon>touch_app</mat-icon>
      Touch Action
    </button>
    <br><br>
  }
  @if (dynamicsInitialized) {
    <div class="settings-section">
      <!-- Text Properties Section -->
      <div class="properties-section">
        <div class="section-header">
          <mat-icon class="section-icon">text_fields</mat-icon>
          <span class="section-title">text properties</span>
        </div>

        <div class="section-content">
          <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
          </dynamic-form>
        </div>
      </div>

      <!-- Font Selector Section -->
      <div class="properties-section">
        <div class="section-header">
          <mat-icon class="section-icon">font_download</mat-icon>
          <span class="section-title">font settings</span>
        </div>

        <div class="section-content">
          <app-font-selector #fontLoader (onChange)="onFontChanged($event, '', 'Label')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
        </div>
      </div>
    </div>
  }
</div>